import { AssetCategory } from 'utils/analytics/AnalyticsV2Service.generated';
import { PackAnalyticsType } from 'types/enums';
import { Pack, PackType, Repack, RepackSubType } from 'types/generated/graphql';

export function getPackAnalyticsType(item: Pack | Repack): PackAnalyticsType {
    if (
        item.type === PackType.Repack &&
        (item as Repack).subType === RepackSubType.Creator
    ) {
        return PackAnalyticsType.Creator;
    }
    if (
        item.type === PackType.Repack &&
        (item as Repack).subType === RepackSubType.Chart
    ) {
        return PackAnalyticsType.Chart;
    }
    if (item.type === PackType.Repack) {
        return PackAnalyticsType.RePack;
    }
    return PackAnalyticsType.Pack;
}

export function getPackAnalyticsTypeV2(
    item: Pack | Repack,
): AssetCategory | undefined {
    if (
        item.type === PackType.Repack &&
        (item as Repack).subType === RepackSubType.Creator
    ) {
        return undefined;
    }
    if (
        item.type === PackType.Repack &&
        (item as Repack).subType === RepackSubType.Chart
    ) {
        return undefined;
    }
    if (item.type === PackType.Repack) {
        return AssetCategory.SampleRepack;
    }
    return AssetCategory.SamplePack;
}
